<template>
    <div class="t_tagtask">
        <el-tabs v-model="subTab" class="t_tagtask_tabs">
            <el-tab-pane label="打标记录" name="task"></el-tab-pane>
            <el-tab-pane label="自动打标规则" name="rule"></el-tab-pane>
        </el-tabs>

        <!-- 打标记录 -->
        <div v-show="subTab === 'task'">
            <div class="t_search_box">
                <div class="t_search_select">
                    <span style="color: #6D6D6D;">任务名称：</span>
                    <el-input style="width: 180px;" size="small" v-model="taskSearch.keyword" clearable placeholder="请输入任务名称" @keyup.enter="searchtask" />
                </div>
                <div class="t_search_select">
                    <span style="color: #6D6D6D;">任务状态：</span>
                    <el-select style="width: 140px;" size="small" v-model="taskSearch.status" clearable placeholder="请选择">
                        <el-option v-for="item in taskStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>
                <div class="t_search_select">
                    <span style="color: #6D6D6D;">创建时间：</span>
                    <el-date-picker
                        size="small"
                        v-model="taskdate"
                        type="daterange"
                        @change="changetaskdate"
                        value-format="YYYY-MM-DD"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                    />
                </div>
                <el-button color="#F1F3F9" style="margin-bottom: 10px;" type="primary" @click="resettask">重置</el-button>
                <el-button color="#F1F3F9" style="margin-bottom: 10px;" type="primary" @click="searchtask">搜索</el-button>
                <el-button color="#F1F3F9" style="margin-bottom: 10px;" type="primary" @click="gettasks">刷新</el-button>
            </div>
            <el-table
                :header-cell-style="{ background: '#F1F3F9' }"
                :data="taskList.data"
                style="width: 100%"
                v-loading="taskLoading">
                <el-table-column prop="task_name" label="任务名称" min-width="220" show-overflow-tooltip />
                <el-table-column label="目标标签" min-width="200">
                    <template #default="scope">
                        <div class="t_tagtask_tags">
                            <el-tag v-for="(name, index) in tagNames(scope.row.tag_ids)" :key="index" type="info" effect="plain">{{ name }}</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="触发方式" width="100">
                    <template #default="scope">{{ scope.row.trigger_type == 2 ? '定时执行' : '手动创建' }}</template>
                </el-table-column>
                <el-table-column label="执行结果" width="210">
                    <template #default="scope">
                        <span class="t_tagtask_count">成功 {{ scope.row.success_count }}</span>
                        <span class="t_tagtask_count">跳过 {{ scope.row.skipped_count }}</span>
                        <span class="t_tagtask_count t_tagtask_count--fail">失败 {{ scope.row.failed_count }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="命中客户" width="100">
                    <template #default="scope">{{ scope.row.total_count }}</template>
                </el-table-column>
                <el-table-column label="状态" width="110">
                    <template #default="scope">
                        <el-tag :type="taskStatusType(scope.row.status)">{{ scope.row.status_text }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="创建时间" width="170" />
                <el-table-column label="操作" width="90" fixed="right">
                    <template #default="scope">
                        <el-button size="small" type="text" @click="opendetail(scope.row)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagechange v-if="taskList.total > 0" :total="taskList.total" :nowpage="taskSearch.page" @page_change="taskpagechange" />
        </div>

        <!-- 自动打标规则 -->
        <div v-show="subTab === 'rule'">
            <div class="t_search_box">
                <div class="t_search_select">
                    <span style="color: #6D6D6D;">规则名称：</span>
                    <el-input style="width: 180px;" size="small" v-model="ruleSearch.keyword" clearable placeholder="请输入规则名称" @keyup.enter="searchrule" />
                </div>
                <div class="t_search_select">
                    <span style="color: #6D6D6D;">规则状态：</span>
                    <el-select style="width: 140px;" size="small" v-model="ruleSearch.status" clearable placeholder="请选择">
                        <el-option label="启用中" :value="1" />
                        <el-option label="已暂停" :value="2" />
                    </el-select>
                </div>
                <el-button color="#F1F3F9" style="margin-bottom: 10px;" type="primary" @click="resetrule">重置</el-button>
                <el-button color="#F1F3F9" style="margin-bottom: 10px;" type="primary" @click="searchrule">搜索</el-button>
                <el-button color="#4F46E5" style="margin-bottom: 10px;" type="primary" @click="openruleform()">新建规则</el-button>
            </div>
            <el-table
                :header-cell-style="{ background: '#F1F3F9' }"
                :data="ruleList.data"
                style="width: 100%"
                v-loading="ruleLoading">
                <el-table-column prop="rule_name" label="规则名称" min-width="180" show-overflow-tooltip />
                <el-table-column label="打标主体" min-width="180">
                    <template #default="scope">{{ corpNames(scope.row.corp_ids) }}</template>
                </el-table-column>
                <el-table-column label="目标标签" min-width="180">
                    <template #default="scope">
                        <div class="t_tagtask_tags">
                            <el-tag v-for="(name, index) in tagNames(scope.row.tag_ids)" :key="index" type="info" effect="plain">{{ name }}</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="执行频率" width="160">
                    <template #default="scope">{{ freqText(scope.row) }}</template>
                </el-table-column>
                <el-table-column label="加粉时间" width="170">
                    <template #default="scope">{{ scope.row.run_mode == 2 ? (scope.row.condition.start_time || '未设置') : '仅新增粉丝' }}</template>
                </el-table-column>
                <el-table-column prop="last_run_at" label="最近执行" width="170">
                    <template #default="scope">{{ scope.row.last_run_at || '--' }}</template>
                </el-table-column>
                <el-table-column label="启用" width="80">
                    <template #default="scope">
                        <el-switch :model-value="scope.row.status == 1" @change="togglerule(scope.row, $event)" />
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="190" fixed="right">
                    <template #default="scope">
                        <el-button size="small" type="text" @click="openruleform(scope.row)">编辑</el-button>
                        <el-button size="small" type="text" @click="runrule(scope.row)">立即执行</el-button>
                        <el-button size="small" type="text" style="color: #F56C6C;" @click="delrule(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagechange v-if="ruleList.total > 0" :total="ruleList.total" :nowpage="ruleSearch.page" @page_change="rulepagechange" />
        </div>

        <!-- 任务详情 -->
        <el-dialog v-model="detail.show" title="打标任务详情" width="780px">
            <div class="t_tagtask_stats">
                <div class="t_tagtask_stat">
                    <span>命中客户</span>
                    <b>{{ detail.task.total_count }}</b>
                </div>
                <div class="t_tagtask_stat">
                    <span>成功</span>
                    <b>{{ detail.task.success_count }}</b>
                </div>
                <div class="t_tagtask_stat">
                    <span>已有标签跳过</span>
                    <b>{{ detail.task.skipped_count }}</b>
                </div>
                <div class="t_tagtask_stat">
                    <span>失败</span>
                    <b class="t_tagtask_stat--fail">{{ detail.task.failed_count }}</b>
                </div>
            </div>
            <el-descriptions :column="2" border size="small">
                <el-descriptions-item label="任务名称">{{ detail.task.task_name }}</el-descriptions-item>
                <el-descriptions-item label="任务状态">{{ detail.task.status_text }}</el-descriptions-item>
                <el-descriptions-item label="触发方式">{{ detail.task.trigger_type == 2 ? '定时执行' : '手动创建' }}</el-descriptions-item>
                <el-descriptions-item label="目标标签">
                    <template v-if="detail.tags.length > 0">
                        <el-tag v-for="item in detail.tags" :key="item.id" type="info" effect="plain" style="margin-right: 6px;">{{ item.tag_name }}</el-tag>
                    </template>
                    <span v-else>--</span>
                </el-descriptions-item>
                <el-descriptions-item label="创建时间">{{ detail.task.created_at }}</el-descriptions-item>
                <el-descriptions-item label="开始时间">{{ detail.task.started_at || '--' }}</el-descriptions-item>
                <el-descriptions-item label="结束时间">{{ detail.task.finished_at || '--' }}</el-descriptions-item>
                <el-descriptions-item label="失败原因">{{ detail.task.err_msg || '--' }}</el-descriptions-item>
            </el-descriptions>
            <div class="t_tagtask_subtitle">
                失败明细
                <span v-if="detail.failures.total > 0">共 {{ detail.failures.total }} 条</span>
            </div>
            <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="detail.failures.data" style="width: 100%" v-loading="detail.loading">
                <el-table-column label="客户" min-width="180">
                    <template #default="scope">
                        <div class="t_tagtask_user">
                            <img v-if="scope.row.avatar" :src="scope.row.avatar" alt="">
                            <span>{{ scope.row.name || ('客户 ' + scope.row.external_contact_id) }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="reason" label="失败原因" min-width="180" />
                <el-table-column prop="created_at" label="失败时间" width="170" />
            </el-table>
            <div v-if="detail.failures.data.length == 0" class="t_tagtask_empty">暂无失败数据</div>
            <pagechange v-if="detail.failures.total > 20" :total="detail.failures.total" :nowpage="detail.failures.page" @page_change="failurepagechange" />
            <template #footer>
                <el-button v-if="canRetry" @click="retryfailed">重试失败客户</el-button>
                <el-button v-if="detail.failures.total > 0" @click="exportfailed">导出失败明细</el-button>
                <el-button color="#4F46E5" type="primary" @click="detail.show = false">关闭</el-button>
            </template>
        </el-dialog>

        <!-- 规则表单 -->
        <el-dialog v-model="ruleForm.show" :title="ruleForm.rule_id > 0 ? '编辑打标规则' : '新建打标规则'" width="640px">
            <el-form label-width="120px">
                <el-form-item label="规则名称" required>
                    <el-input v-model="ruleForm.rule_name" maxlength="100" show-word-limit placeholder="请输入规则名称" />
                </el-form-item>
                <el-form-item label="打标主体" required>
                    <el-select style="width: 100%;" v-model="ruleForm.corp_ids" multiple filterable clearable placeholder="请选择打标主体">
                        <el-option v-for="(item, index) in corpList.data" :key="index" :label="item.corp_name" :value="item.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="目标标签" required>
                    <el-select style="width: 100%;" v-model="ruleForm.tag_ids" multiple filterable clearable placeholder="请选择要添加的标签">
                        <el-option v-for="(item, index) in tagList.data" :key="index" :label="item.tag_name" :value="item.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="执行频率" required>
                    <div class="t_tagtask_freq">
                        <el-select style="width: 120px;" v-model="ruleForm.freq_type">
                            <el-option label="每天" :value="1" />
                            <el-option label="每 N 小时" :value="2" />
                            <el-option label="每周" :value="3" />
                        </el-select>
                        <template v-if="ruleForm.freq_type == 1">
                            <el-time-select v-model="ruleForm.daily_time" style="width: 130px;" start="00:00" step="00:30" end="23:30" placeholder="执行时刻" />
                        </template>
                        <template v-else-if="ruleForm.freq_type == 2">
                            <el-input-number v-model="ruleForm.hours" :min="1" :max="24" style="width: 130px;" />
                            <span class="t_tagtask_hint">小时执行一次</span>
                        </template>
                        <template v-else>
                            <el-select style="width: 110px;" v-model="ruleForm.weekday">
                                <el-option v-for="item in weekdayOptions" :key="item.value" :label="item.label" :value="item.value" />
                            </el-select>
                            <el-time-select v-model="ruleForm.weekly_time" style="width: 130px;" start="00:00" step="00:30" end="23:30" placeholder="执行时刻" />
                        </template>
                    </div>
                </el-form-item>
                <el-form-item label="首次执行">
                    <el-switch v-model="ruleForm.backfill" active-text="回溯历史客户" inactive-text="仅处理新增客户" />
                    <div v-if="ruleForm.backfill" class="t_tagtask_backfill">
                        <span>起始加粉时间：</span>
                        <el-date-picker
                            v-model="ruleForm.start_time"
                            type="datetime"
                            value-format="YYYY-MM-DD HH:mm:ss"
                            placeholder="首次执行从该时间开始回溯"
                        />
                    </div>
                    <div class="t_tagtask_hint">仅处理新增客户：只对规则创建后添加的粉丝打标；回溯历史客户：首次执行从起始加粉时间开始补齐。</div>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="ruleForm.show = false">取消</el-button>
                <el-button color="#4F46E5" type="primary" :loading="ruleForm.submitting" @click="saverule">保存</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, reactive, computed, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import pagechange from '../components/pagechange.vue'
import {
    newtagtasklist,
    newtagtaskdetail,
    newtagtaskretry,
    newtagtaskexport,
    newtagrulelist,
    newtagrulesave,
    newtagruletoggle,
    newtagruledelete,
    newtagrulerun,
    newgetcomp2,
    newgettaglist
} from '@/assets/js/common.js'

const subTab = ref('task')

const weekdayOptions = [
    { value: 1, label: '周一' },
    { value: 2, label: '周二' },
    { value: 3, label: '周三' },
    { value: 4, label: '周四' },
    { value: 5, label: '周五' },
    { value: 6, label: '周六' },
    { value: 7, label: '周日' }
]

const taskStatusOptions = [
    { value: 0, label: '待执行' },
    { value: 1, label: '执行中' },
    { value: 2, label: '已完成' },
    { value: 3, label: '部分失败' },
    { value: 4, label: '执行失败' },
    { value: 5, label: '无匹配客户' }
]

// 企微主体下拉
const corpList = reactive({
    data: []
})
const getcorplist = () => {
    newgetcomp2().then((response) => {
        if (response.data.msg.code == 0) {
            corpList.data = response.data.data
        }
    })
}
const corpNames = (ids) => {
    if (!ids || ids.length == 0) {
        return '--'
    }
    const names = ids.map((id) => {
        const corp = corpList.data.find((item) => String(item.id) === String(id))
        return corp ? corp.corp_name : ''
    }).filter((name) => name != '')
    return names.length > 0 ? names.join('、') : '--'
}

// 标签下拉
const tagList = reactive({
    data: []
})
const gettaglist = () => {
    newgettaglist().then((response) => {
        if (response.data.msg.code == 0) {
            tagList.data = []
            const groups = response.data.data || []
            groups.forEach((group) => {
                (group.tags || []).forEach((tag) => {
                    tagList.data.push(tag)
                })
            })
        }
    })
}
const tagNames = (ids) => {
    if (!ids || ids.length == 0) {
        return []
    }
    return ids.map((id) => {
        const tag = tagList.data.find((item) => String(item.id) === String(id))
        return tag ? tag.tag_name : ('标签 ' + id)
    })
}

const taskStatusType = (status) => {
    if (status == 2) {
        return 'success'
    }
    if (status == 3) {
        return 'warning'
    }
    if (status == 4) {
        return 'danger'
    }
    if (status == 1) {
        return 'warning'
    }
    return 'info'
}

// 打标记录列表
const taskLoading = ref(false)
const taskdate = ref([])
const taskSearch = reactive({
    page: 1,
    page_size: 20,
    keyword: '',
    status: '',
    start_time: '',
    end_time: ''
})
const taskList = reactive({
    data: [],
    total: 0
})

const gettasks = () => {
    taskLoading.value = true
    newtagtasklist({
        page: taskSearch.page,
        page_size: taskSearch.page_size,
        keyword: taskSearch.keyword,
        status: taskSearch.status,
        start_time: taskSearch.start_time,
        end_time: taskSearch.end_time
    }).then((response) => {
        taskLoading.value = false
        if (response.data.msg.code == 0) {
            taskList.data = response.data.data.data
            taskList.total = response.data.data.total
        } else {
            ElMessage({
                message: response.data.msg.info || '获取打标任务失败',
                type: 'warning'
            })
        }
    }).catch(() => {
        taskLoading.value = false
    })
}

const searchtask = () => {
    taskSearch.page = 1
    gettasks()
}

const resettask = () => {
    taskSearch.keyword = ''
    taskSearch.status = ''
    taskSearch.start_time = ''
    taskSearch.end_time = ''
    taskdate.value = []
    taskSearch.page = 1
    gettasks()
}

const changetaskdate = (val) => {
    if (val && val.length == 2) {
        taskSearch.start_time = val[0] + ' 00:00:00'
        taskSearch.end_time = val[1] + ' 23:59:59'
    } else {
        taskSearch.start_time = ''
        taskSearch.end_time = ''
    }
}

const taskpagechange = (page) => {
    taskSearch.page = page
    gettasks()
}

// 任务详情
const detail = reactive({
    show: false,
    loading: false,
    id: 0,
    task: {},
    tags: [],
    failures: {
        data: [],
        total: 0,
        page: 1,
        page_size: 20
    }
})

const opendetail = (row) => {
    detail.id = row.id
    detail.task = row
    detail.tags = []
    detail.failures.data = []
    detail.failures.total = 0
    detail.failures.page = 1
    detail.show = true
    getdetail()
}

const getdetail = () => {
    detail.loading = true
    newtagtaskdetail({
        id: detail.id,
        page: detail.failures.page,
        page_size: detail.failures.page_size
    }).then((response) => {
        detail.loading = false
        if (response.data.msg.code == 0) {
            const data = response.data.data
            detail.task = data.task
            detail.tags = data.tags || []
            detail.failures.data = data.failures.data || []
            detail.failures.total = data.failures.total || 0
            detail.failures.page = data.failures.page || 1
        } else {
            ElMessage({
                message: response.data.msg.info || '获取任务详情失败',
                type: 'warning'
            })
        }
    }).catch(() => {
        detail.loading = false
    })
}

const failurepagechange = (page) => {
    detail.failures.page = page
    getdetail()
}

const canRetry = computed(() => {
    return (detail.task.status == 3 || detail.task.status == 4) && detail.failures.total > 0
})

const retryfailed = () => {
    newtagtaskretry({ id: detail.id }).then((response) => {
        if (response.data.msg.code == 0) {
            ElMessage({
                message: '已创建重试任务',
                type: 'success'
            })
            detail.show = false
            gettasks()
        } else {
            ElMessage({
                message: response.data.msg.info || '重试失败',
                type: 'warning'
            })
        }
    })
}

const csvcell = (value) => {
    const text = String(value == null ? '' : value)
    return '"' + text.replace(/"/g, '""') + '"'
}

const exportfailed = () => {
    newtagtaskexport({ id: detail.id }).then((response) => {
        if (response.data.msg.code != 0) {
            ElMessage({
                message: response.data.msg.info || '导出失败',
                type: 'warning'
            })
            return
        }
        const rows = response.data.data.rows || []
        if (rows.length == 0) {
            ElMessage({
                message: '暂无失败明细',
                type: 'warning'
            })
            return
        }
        const lines = [['客户ID', '客户名称', '失败原因', '失败时间'].join(',')]
        rows.forEach((row) => {
            lines.push([
                csvcell(row.external_contact_id),
                csvcell(row.name),
                csvcell(row.reason),
                csvcell(row.created_at)
            ].join(','))
        })
        const blob = new Blob(['\uFEFF' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = '打标失败明细_' + detail.id + '_' + new Date().getTime() + '.csv'
        link.click()
        URL.revokeObjectURL(link.href)
    })
}

// 自动打标规则
const ruleLoading = ref(false)
const ruleSearch = reactive({
    page: 1,
    page_size: 20,
    keyword: '',
    status: ''
})
const ruleList = reactive({
    data: [],
    total: 0
})

const getrules = () => {
    ruleLoading.value = true
    newtagrulelist({
        page: ruleSearch.page,
        page_size: ruleSearch.page_size,
        rule_type: 2,
        keyword: ruleSearch.keyword,
        status: ruleSearch.status
    }).then((response) => {
        ruleLoading.value = false
        if (response.data.msg.code == 0) {
            ruleList.data = response.data.data.data
            ruleList.total = response.data.data.total
        } else {
            ElMessage({
                message: response.data.msg.info || '获取打标规则失败',
                type: 'warning'
            })
        }
    }).catch(() => {
        ruleLoading.value = false
    })
}

const searchrule = () => {
    ruleSearch.page = 1
    getrules()
}

const resetrule = () => {
    ruleSearch.keyword = ''
    ruleSearch.status = ''
    ruleSearch.page = 1
    getrules()
}

const rulepagechange = (page) => {
    ruleSearch.page = page
    getrules()
}

const freqText = (rule) => {
    if (rule.freq_type == 1) {
        return '每天 ' + rule.freq_value
    }
    if (rule.freq_type == 2) {
        return '每 ' + rule.freq_value + ' 小时'
    }
    if (rule.freq_type == 3) {
        const parts = String(rule.freq_value || '').split(' ')
        const weekday = weekdayOptions.find((item) => String(item.value) === parts[0])
        return '每' + (weekday ? weekday.label : '周') + ' ' + (parts[1] || '')
    }
    return '--'
}

const togglerule = (row, checked) => {
    const status = checked ? 1 : 2
    newtagruletoggle({ id: row.id, status: status }).then((response) => {
        if (response.data.msg.code == 0) {
            ElMessage({
                message: status == 1 ? '规则已启用' : '规则已暂停',
                type: 'success'
            })
            getrules()
        } else {
            ElMessage({
                message: response.data.msg.info || '操作失败',
                type: 'warning'
            })
        }
    })
}

const runrule = (row) => {
    newtagrulerun({ id: row.id }).then((response) => {
        if (response.data.msg.code == 0) {
            ElMessage({
                message: '已创建打标任务',
                type: 'success'
            })
            gettasks()
            getrules()
        } else {
            ElMessage({
                message: response.data.msg.info || '执行失败',
                type: 'warning'
            })
        }
    })
}

const delrule = (row) => {
    ElMessageBox.confirm('删除后该规则不再执行，已产生的打标记录不受影响，是否继续？', '删除规则', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        return newtagruledelete({ id: row.id })
    }).then((response) => {
        if (response && response.data.msg.code == 0) {
            ElMessage({
                message: '规则已删除',
                type: 'success'
            })
            getrules()
        } else if (response) {
            ElMessage({
                message: response.data.msg.info || '删除失败',
                type: 'warning'
            })
        }
    }).catch(() => {})
}

const ruleForm = reactive({
    show: false,
    submitting: false,
    rule_id: 0,
    rule_name: '',
    corp_ids: [],
    tag_ids: [],
    freq_type: 1,
    daily_time: '09:00',
    hours: 6,
    weekday: 1,
    weekly_time: '09:00',
    backfill: false,
    start_time: ''
})

const openruleform = (row) => {
    ruleForm.rule_id = row ? row.id : 0
    ruleForm.rule_name = row ? row.rule_name : ''
    ruleForm.corp_ids = row ? (row.corp_ids || []).map(Number) : []
    ruleForm.tag_ids = row ? (row.tag_ids || []).map(Number) : []
    ruleForm.freq_type = row ? row.freq_type : 1
    ruleForm.daily_time = '09:00'
    ruleForm.hours = 6
    ruleForm.weekday = 1
    ruleForm.weekly_time = '09:00'
    ruleForm.backfill = row ? row.run_mode == 2 : false
    ruleForm.start_time = row && row.condition ? (row.condition.start_time || '') : ''
    if (row) {
        if (row.freq_type == 1) {
            ruleForm.daily_time = row.freq_value || '09:00'
        } else if (row.freq_type == 2) {
            ruleForm.hours = Number(row.freq_value) || 6
        } else if (row.freq_type == 3) {
            const parts = String(row.freq_value || '').split(' ')
            ruleForm.weekday = Number(parts[0]) || 1
            ruleForm.weekly_time = parts[1] || '09:00'
        }
    }
    ruleForm.show = true
}

const saverule = () => {
    if (ruleForm.rule_name.trim() == '') {
        ElMessage({
            message: '请填写规则名称',
            type: 'warning'
        })
        return
    }
    if (ruleForm.corp_ids.length == 0) {
        ElMessage({
            message: '请选择打标主体',
            type: 'warning'
        })
        return
    }
    if (ruleForm.tag_ids.length == 0) {
        ElMessage({
            message: '请选择目标标签',
            type: 'warning'
        })
        return
    }
    let freqValue = ''
    if (ruleForm.freq_type == 1) {
        if (!ruleForm.daily_time) {
            ElMessage({
                message: '请选择执行时刻',
                type: 'warning'
            })
            return
        }
        freqValue = ruleForm.daily_time
    } else if (ruleForm.freq_type == 2) {
        freqValue = String(ruleForm.hours)
    } else {
        if (!ruleForm.weekly_time) {
            ElMessage({
                message: '请选择执行时刻',
                type: 'warning'
            })
            return
        }
        freqValue = ruleForm.weekday + ' ' + ruleForm.weekly_time
    }
    if (ruleForm.backfill && !ruleForm.start_time) {
        ElMessage({
            message: '请选择起始加粉时间',
            type: 'warning'
        })
        return
    }

    const condition = {}
    if (ruleForm.backfill && ruleForm.start_time) {
        condition.start_time = ruleForm.start_time
    }

    ruleForm.submitting = true
    newtagrulesave({
        rule_id: ruleForm.rule_id,
        rule_name: ruleForm.rule_name.trim(),
        corp_ids: ruleForm.corp_ids,
        tag_ids: ruleForm.tag_ids,
        condition: condition,
        freq_type: ruleForm.freq_type,
        freq_value: freqValue,
        run_mode: ruleForm.backfill ? 2 : 1
    }).then((response) => {
        ruleForm.submitting = false
        if (response.data.msg.code == 0) {
            ElMessage({
                message: '规则已保存',
                type: 'success'
            })
            ruleForm.show = false
            getrules()
        } else {
            ElMessage({
                message: response.data.msg.info || '保存失败',
                type: 'warning'
            })
        }
    }).catch(() => {
        ruleForm.submitting = false
    })
}

onBeforeMount(() => {
    getcorplist()
    gettaglist()
    gettasks()
    getrules()
})
</script>

<style scoped>
.t_tagtask_tabs {
    margin-bottom: 10px;
}

.t_tagtask_tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.t_tagtask_count {
    margin-right: 10px;
    color: #4E5969;
}

.t_tagtask_count--fail {
    color: #F56C6C;
}

.t_tagtask_empty {
    padding: 40px 0;
    text-align: center;
    color: #909399;
    font-size: 14px;
}

.t_tagtask_stats {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
}

.t_tagtask_stat {
    flex: 1;
    background-color: #F1F3F9;
    border-radius: 8px;
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    color: #4E5969;
    font-size: 13px;
}

.t_tagtask_stat b {
    font-size: 20px;
    color: #1D2129;
}

.t_tagtask_stat b.t_tagtask_stat--fail {
    color: #F56C6C;
}

.t_tagtask_subtitle {
    margin: 20px 0 10px;
    font-size: 14px;
    font-weight: 600;
    color: #1D2129;
}

.t_tagtask_subtitle span {
    margin-left: 8px;
    font-size: 13px;
    font-weight: 400;
    color: #909399;
}

.t_tagtask_user {
    display: flex;
    align-items: center;
    gap: 8px;
}

.t_tagtask_user img {
    width: 26px;
    height: 26px;
    border-radius: 50%;
}

.t_tagtask_freq {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.t_tagtask_hint {
    width: 100%;
    margin-top: 4px;
    font-size: 12px;
    color: #909399;
    line-height: 20px;
}

.t_tagtask_backfill {
    display: flex;
    align-items: center;
    margin-top: 10px;
    color: #4E5969;
}

:deep(.t_tagtask_tabs .el-tabs__item.is-active) {
    color: #4F46E5;
}

:deep(.t_tagtask_tabs .el-tabs__active-bar) {
    background-color: #4F46E5;
}
</style>
